import ReactDOM from 'react-dom';
import React from 'react';
import App from './App';
import './index.css';
import { RecoilRoot } from 'recoil';

ReactDOM.render(
<RecoilRoot>
  <App />
</RecoilRoot>, document.getElementById('root'));